import type { Skill } from './SkillCatalog'
import { BetaBadge } from '../../components/BetaBadge'
import './SkillSelector.css'

interface SkillSelectorProps {
  skills: Skill[]
  selected: string[]
  onChange: (selected: string[]) => void
}

export default function SkillSelector({ skills, selected, onChange }: SkillSelectorProps) {
  const toggleSkill = (skillId: string, required: boolean) => {
    if (required) return // Can't toggle required skills
    
    if (selected.includes(skillId)) {
      onChange(selected.filter(s => s !== skillId))
    } else {
      onChange([...selected, skillId])
    }
  }

  return (
    <div className="skill-selector-grid">
      {skills.map((skill) => {
        const isSelected = selected.includes(skill.id)
        const isDisabled = skill.comingSoon
        const IconComponent = skill.icon
        
        return (
          <button
            key={skill.id}
            type="button"
            className={`skill-box${isSelected ? ' selected' : ''}${isDisabled ? ' disabled' : ''}${skill.required ? ' required' : ''}`}
            onClick={() => !isDisabled && toggleSkill(skill.id, skill.required)}
            disabled={isDisabled}
          >
            <div className="skill-box-icon">
              <IconComponent size={40} strokeWidth={1.5} />
            </div>
            <div className="skill-box-content">
              <h3 className="skill-box-title">
                {skill.name}
                {skill.beta && <BetaBadge />}
              </h3>
              <p className="skill-box-description">{skill.description}</p>
            </div>
            {skill.required && (
              <div className="skill-box-badge required">Required</div>
            )}
            {skill.comingSoon && (
              <div className="skill-box-badge coming-soon">Coming Soon</div>
            )}
            {!skill.required && !skill.comingSoon && (
              <div className="skill-box-check">
                {isSelected ? '✓' : ''}
              </div>
            )}
          </button>
        )
      })}
    </div>
  )
}
